/**
 * ダッシュボードページ用のスクリプト
 */
if (is_route('bss_dashboard.index')) {
    // スクリプト読込
    require('../Base/dashboard_base.index');

    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        dashboard_base_event_set();
        dashboard_base_setting_event_set();
    });
}